import { createAction } from '@reduxjs/toolkit';

export const requestCreateCollection = createAction('request/createCollection');
export const requestViewAllCollections = createAction('request/viewAllCollections');
export const requestUpdateCollection = createAction('request/updateCollection');
export const requestDeleteCollection = createAction('request/deleteCollection');
